import { Box, TextField, Typography } from '@mui/material';
import { useKpiWorkLogFormContext } from '../../hooks';
import { KPI_POB_FIELD_KEY } from '../../constants';

export const KpiPobFilter = () => {
  const { formik } = useKpiWorkLogFormContext();

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value;
    const currentPob = formik.values?.[KPI_POB_FIELD_KEY];

    if (value === '') {
      formik.setFieldValue(KPI_POB_FIELD_KEY, { ...currentPob, value: '' });
      return;
    }
    const numValue = Number.parseInt(value, 10);
    if (!Number.isNaN(numValue) && numValue >= 1 && numValue <= 100) {
      formik.setFieldValue(KPI_POB_FIELD_KEY, { ...currentPob, value: numValue });
    }
  };

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
      <Typography color="primary.light">POB:</Typography>
      <TextField
        id="kpi-tracker-pob-filter-input"
        type="number"
        value={formik.values?.[KPI_POB_FIELD_KEY]?.value ?? ''}
        onChange={handleChange}
        size="small"
        inputProps={{
          min: 1,
          max: 100,
        }}
        sx={{
          borderRadius: 0,
          width: 60,
          '& .MuiInputBase-root': {
            height: 26,
            borderRadius: 0,
          },
          '& .MuiInputBase-input': {
            py: 0.5,
            px: 1,
            fontSize: '12px',
            fontWeight: 600,
          },
          '& .MuiOutlinedInput-notchedOutline': {
            border: '1px solid',
            borderColor: 'text.secondary',
          },
        }}
      />
    </Box>
  );
};
